import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.min.css"

const TopImage: React.FC = () => {
  const data = useStaticQuery<GatsbyTypes.TopImageQuery>(graphql`
    query TopImage {
      desktopImage1: file(relativePath: { eq: "Jmof-2022.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      desktopImage2: file(relativePath: { eq: "Jmof-2022-2.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      desktopImage3: file(relativePath: { eq: "Jmof-2022-3.png" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      mobileImage1: file(relativePath: { eq: "Jmof-2022-sp.png" }) {
        childImageSharp {
          fluid(maxWidth: 640) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      mobileImage2: file(relativePath: { eq: "Jmof-2022-sp-2.png" }) {
        childImageSharp {
          fluid(maxWidth: 640) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      mobileImage3: file(relativePath: { eq: "Jmof-2022-sp-3.png" }) {
        childImageSharp {
          fluid(maxWidth: 640) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  if (
    !data?.desktopImage1?.childImageSharp?.fluid ||
    !data?.desktopImage2?.childImageSharp?.fluid ||
    !data?.mobileImage1?.childImageSharp?.fluid ||
    !data?.mobileImage2?.childImageSharp?.fluid
  ) {
    return <div>Picture not found</div>
  }

  const img1 = [
    data.desktopImage1.childImageSharp.fluid,
    {
      ...data.mobileImage1.childImageSharp.fluid,
      media: `(max-width: 600px)`,
    },
  ]
  const img2 = [
    data.desktopImage2.childImageSharp.fluid,
    {
      ...data.mobileImage2.childImageSharp.fluid,
      media: `(max-width: 600px)`,
    },
  ]
  const img3 = [
    data.desktopImage3.childImageSharp.fluid,
    {
      ...data.mobileImage3.childImageSharp.fluid,
      media: `(max-width: 600px)`,
    },
  ]

  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      effect="fade"
      speed={1500}
      autoplay={{
        delay: 7500,
      }}
      pagination
    >
      <SwiperSlide>
        <Img fluid={img3} style={{ backgroundColor: "#000" }} />
      </SwiperSlide>
      <SwiperSlide>
        <Img fluid={img2} style={{ backgroundColor: "#000" }} />
      </SwiperSlide>
      <SwiperSlide>
        <Img fluid={img1} style={{ backgroundColor: "#000" }} />
      </SwiperSlide>
    </Swiper>
  )
}

export default TopImage
